import { tableAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(tableAnatomy.keys);
const baseStyle = definePartsStyle({
    thead: {
        th: {
            height: '100%',
            p: 0,
            textTransform: 'none',
            fontWeight: '400'
        }
    },
    tbody: {
        td: {
            lineHeight: 1
        }
    }
});
export const tableTheme = defineMultiStyleConfig({ baseStyle });
//# sourceMappingURL=_table.theme.js.map